/*
 * @Author: your name
 * @Date: 2020-08-19 16:28:05
 * @LastEditTime: 2020-09-07 18:40:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/config.js
 */
import Vue from 'vue';
import { validateSchemeName } from '@/api/payroll/pay-slip';
var $t = Vue.prototype.$t;
var validator = function validator(rlue, value, cb) {
  if (!value) cb(rlue.message);else if (value && rlue.state !== 3) {
    // 验证工资条姓名是否可用
    var query = {
      name: value
    };
    if (rlue.state === 2) query.payslip_scheme_id = infoData[2].formData.payslip_scheme_id;
    validateSchemeName(query).then(function (res) {
      if (res.data) cb();else if (!res.data) {
        rlue.message = $t('pay_slip_30');
        cb(rlue.message);
      }
    });
  } else cb();
};
export var infoData = {
  // 创建
  1: {
    title: $t('pay_slip_4'),
    formLabel: {
      // 是否展示该项
      name: $t('1085'),
      type: $t('payroll_salary_24'),
      tax_deduction_status: $t('421'),
      drop: true // 拖拽
    },

    formData: {
      // 需填写的字段
      name: '',
      // 工资条名称
      type: '',
      tax_deduction_status: '' // 税
    },

    formRules: {
      name: [{
        required: true,
        validator: validator,
        state: 1,
        message: $t('1593'),
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: $t('1593'),
        trigger: 'change'
      }],
      tax_deduction_status: [{
        required: true,
        message: $t('1593'),
        trigger: 'change'
      }]
    },
    button: {
      // 需展示的按钮
      pdfView: $t('pdf_view'),
      savePaysilp: $t('pay_slip_5')
      // submit_btn: $t('submit_btn')
      // sendPaysilp: $t('225')
    }
  },

  // 模版编辑
  2: {
    title: $t('1083'),
    formLabel: {
      name: $t('1085'),
      type: $t('payroll_salary_24'),
      tax_deduction_status: $t('421'),
      drop: true // 拖拽
    },

    formData: {
      payslip_scheme_id: '',
      name: '',
      // 工资条名称
      type: '',
      tax_deduction_status: '' // 税
    },

    formRules: {
      name: [{
        required: true,
        validator: validator,
        state: 2,
        message: $t('1593'),
        trigger: 'blur'
      }],
      type: [{
        required: true,
        message: $t('1593'),
        trigger: 'change'
      }],
      tax_deduction_status: [{
        required: true,
        message: $t('1593'),
        trigger: 'change'
      }]
    },
    button: {
      pdfView: $t('pdf_view'),
      savePaysilp: $t('pay_slip_5')
      // submit_btn: $t('submit_btn')
      // sendPaysilp: $t('225')
    }
  },

  // 去发工资条
  3: {
    title: $t('pay_slip_2'),
    formLabel: {
      name: $t('1418'),
      send_way: $t('pay_slip_17'),
      send_time_type: $t('pay_slip_15'),
      send_time: $t('pay_slip_15'),
      drop: true // 拖拽
    },

    formData: {
      send_way: [],
      // 0 app 1个人 2企业,多选用,分割
      send_time_type: '',
      // 0,立即发动 1定时
      send_time: '',
      // 发动时间
      status: '',
      // 0，正常 1覆盖上一次
      is_cover: false,
      // 是否展示覆盖上一次
      name: '' // 工资条名称
    },

    formRules: {
      name: [{
        required: true,
        validator: validator,
        state: 3,
        message: $t('1593'),
        trigger: 'blur'
      }],
      send_way: [{
        required: true,
        message: $t('1593'),
        trigger: 'change'
      }],
      send_time: [{
        required: true,
        message: $t('1593'),
        trigger: 'blur'
      }],
      send_time_type: [{
        required: true,
        message: $t('1593'),
        trigger: 'change'
      }]
    },
    button: {
      pdfView: $t('pdf_view'),
      sendPaysilp: $t('225')
      // savePaysilp: $t('pay_slip_5')
      // submit_btn: $t('submit_btn')
    }
  },

  // 查看设置工资条
  4: {
    title: $t('pay_slip_12'),
    formLabel: {},
    formData: {
      name: '',
      // 工资条名称
      payroll_scheme_id: '',
      tax_deduction_status: '' // 税
    },

    button: {
      pdfView: $t('pdf_view')
      // sendPaysilp: $t('225')
      // savePaysilp: $t('pay_slip_5')
      // submit_btn: $t('submit_btn')
    }
  }
};